export default defineNuxtPlugin((nuxtApp) => {
  const head = nuxtApp.vueApp.runWithContext(() => injectHead());

  for (const plugin of seoHeadPlugins(useSiteOrigin())) head.use(plugin);
});
